import Badge from "@material-ui/core/Badge";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AddBusinessIcon from "@material-ui/icons/Add";
import CropFreeIcon from "@material-ui/icons/CropFree";
import HomeIcon from "@material-ui/icons/Home";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import ProfileIcon from "@material-ui/icons/Person";
import BasketIcon from "@material-ui/icons/ShoppingBasket";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { fetchBasket } from "../../services/basket/actions";
import "./BottomNavBar.scss";

const useStyles = makeStyles((theme) => ({
	BottomNavBar: {
		width: "100%",
		display: "flex",
		alignItems: "stretch" /* Default */,
		justifyContent: "space-evenly",
		margin: 0,
		padding: 0,
	},

	BottomNavBar_list_item: {
		cursor: "pointer",
		color: "#333333",
		fontWeight: 700,
		float: "left",
		height: "40px",
		display: "block",
	},
}));

const StyledBadge = withStyles((theme) => ({
	badge: {
		right: -5,
		top: 5,
		border: `2px solid #ffffff`,
		padding: "0 4px",
	},
}))(Badge);

function BottomNavBar(props) {
	const [basketTotal, setBasketTotal] = useState(0);
	const classes = useStyles(props);

	useEffect(() => {
		if (props.loginSuccesful) {
			props.fetchBasket(props.currentLocation.id, props.userId);
			// disable fetchAll dependency warning
			// eslint-disable-next-line
		}
	}, []);

	const handleBasketCount = () => {
		let temp = 0;
		if (props.basketProducts) {
			if (!Array.isArray(props.basketProducts)) {
				props.basketProducts.basket.map((row) => (temp += row.number));
				setBasketTotal(temp);
			} else {
				props.basketProducts.map((row) => (temp += row.number));
				setBasketTotal(temp);
			}
		}
		setBasketTotal(temp);
	};

	useEffect(() => {
		handleBasketCount();
	}, [props.basketProducts]);

	return props.loginSuccesful ? (
		<div className="BottomNavBarWrapper">
			<ul className={classes.BottomNavBar}>
				{props.farmers ? (
					<Link to="/home" style={{ textDecoration: "none" }}>
						<li className={classes.BottomNavBar_list_item}>
							<HomeIcon />
						</li>
					</Link>
				) : null}
				{props.farmers ? (
					<Link to="/farmersassortiment" style={{ textDecoration: "none" }}>
						<li className={classes.BottomNavBar_list_item}>
							<ManageSearchIcon />
						</li>
					</Link>
				) : (
					<Link to="/assortiment" style={{ textDecoration: "none" }}>
						<li className={classes.BottomNavBar_list_item}>
							<ManageSearchIcon />
						</li>
					</Link>
				)}
				{props.farmers && (
					<Link to="/allsuppliers" style={{ textDecoration: "none" }}>
						<li className={classes.BottomNavBar_list_item}>
							<AgricultureIcon />
						</li>
					</Link>
				)}
				{props.add_barcodes ? (
					<Link to="/addbarcode" style={{ textDecoration: "none" }}>
						<li className={classes.BottomNavBar_list_item}>
							<AddBusinessIcon />
						</li>
					</Link>
				) : null}
				<Link to="/basket" style={{ textDecoration: "none" }}>
					<li className={classes.BottomNavBar_list_item}>
						<StyledBadge badgeContent={basketTotal} color="primary">
							<BasketIcon />
						</StyledBadge>
					</li>
				</Link>
				{props.stock_count ? (
					<Link to="/scanner" style={{ textDecoration: "none" }}>
						<li className={classes.BottomNavBar_list_item}>
							<CropFreeIcon />
						</li>
					</Link>
				) : null}
				<Link to="/profile" style={{ textDecoration: "none" }}>
					<li className={classes.BottomNavBar_list_item}>
						<ProfileIcon />
					</li>
				</Link>
			</ul>
		</div>
	) : (
		<div className="BottomNavBarWrapper">
			<ul className={classes.BottomNavBar}>
				<Link to="/home" style={{ textDecoration: "none" }}>
					<li className={classes.BottomNavBar_list_item}>
						<HomeIcon />
					</li>
				</Link>
				<Link to="/publicassortiment" style={{ textDecoration: "none" }}>
					<li className={classes.BottomNavBar_list_item}>
						<ManageSearchIcon />
					</li>
				</Link>
				<Link to="/allsuppliers" style={{ textDecoration: "none" }}>
					<li className={classes.BottomNavBar_list_item}>
						<AgricultureIcon />
					</li>
				</Link>
				<Link
					style={{ textDecoration: "none" }}
					to={{
						pathname: "/login",
						state: { bottomnav: true },
					}}
				>
					<li className={classes.BottomNavBar_list_item}>
						<LockOpenIcon />
					</li>
				</Link>
			</ul>
		</div>
	);
}

const mapStateToProps = (state) => ({
	basketProducts: state.basket.products,
	userId: state.login.data.user_id,
	add_barcodes: state.login.data.add_barcodes,
	stock_count: state.login.data.stock_count,
	currentLocation: state.currentInformation.current_location,
	identifyInfo: state.identify.identifyInfo,
	loginSuccesful: state.login.data.loginSuccesful,
	farmers: state.login.data.farmers,
});

export default connect(mapStateToProps, { fetchBasket })(BottomNavBar);
